<app-table [data]="insertionCycles"
           [config]="tableConfig"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.insertion-cycles.table.title' | translate}}"
           [rowExpand]="false"
           [rowDuplicate]="true"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [isLoading]="isLoading"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.insertion-cycles.table.columns.id' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.insertion-cycles.table.columns.name' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.insertion-cycles.table.filter.placeholder.name' | translate}}"
                      sortable="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.insertion-cycles.table.columns.assignedLines' | translate}}"
                      sortable="true"
                      field="assignedLinesString">
    </app-table-column>
</app-table>
